import React, { useState } from 'react';
import { MessageSquareText } from 'lucide-react';
import { Button } from '../ui/button';
import BookingTextDialog, { ukStamp } from './BookingTextDialog';

// Admin only: build the booking text for a job and keep a record of it
export const BookingTextButton = ({ job, token, onLogged }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}
              data-testid={`booking-text-open-${job.id}`}>
        <MessageSquareText className="mr-1 h-4 w-4" />
        Create booking text
      </Button>
      <BookingTextDialog
        job={job}
        token={token}
        open={open}
        onClose={() => setOpen(false)}
        onLogged={onLogged}
      />
    </>
  );
};

export const BookingTextHistory = ({ sent, jobId }) => {
  if (!sent || sent.length === 0) return null;
  const newestFirst = [...sent].sort((a, b) =>
    String(b.sent_at || '').localeCompare(String(a.sent_at || '')));
  return (
    <div className="mt-3 rounded-[10px] border border-hair bg-page p-3"
         data-testid={`booking-texts-sent-${jobId}`}>
      <p className="text-[11px] font-semibold text-slate-500">Booking texts sent</p>
      <ul className="mt-1 space-y-0.5">
        {newestFirst.map((row) => (
          <li key={row.id || row.sent_at} className="text-[11px] text-slate-600">
            {row.method} to {row.staff_name}, {ukStamp(row.sent_at)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BookingTextButton;
